import { getFilteredOperation } from "../../../../../actions/Utilities/EmailWorkFlow";
import { useQuery } from "react-query";

export default function useFilteredOperation() {
  return useQuery("FilteredOperation", getFilteredOperation, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
}
